/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Content_StatsInputs */

const en_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Advanced<span style="[%2$s]"> focus analysis</span></span>`)
};

const ar_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">تحليل تركيز<span style="[%2$s]">متقدم</span></span>`)
};

const de_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Fortgeschrittene<span style="[%2$s]"> Fokusanalyse</span></span>`)
};

const es_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Análisis de<span style="[%2$s]"> concentración avanzado</span></span>`)
};

const fr_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Analyse de concentration</span> avancée</span>`)
};

const it_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Analisi della concentrazione</span> avanzata</span>`)
};

const ja_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">高度な<span style="[%2$s]">集中力分析</span></span>`)
};

const ko_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">고급<span style="[%2$s]"> 집중 분석</span></span>`)
};

const pt_br_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Análise de foco</span> avançada</span>`)
};

const ru_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Расширенный <span style="[%2$s]">анализ фокусировки</span></span>`)
};

const th_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">การวิเคราะห์โฟกัส</span>ขั้นสูง</span>`)
};

const tr_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Gelişmiş <span style="[%2$s]">odaklanma anali̇zi̇</span></span>`)
};

const zh_cn_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">进阶<span style="[%2$s]">专注表现分析</span></span>`)
};

const zh_tw_subscription_walkthrough_p1_content_stats = /** @type {(inputs: Subscription_Walkthrough_P1_Content_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">進階<span style="[%2$s]">專注表現分析</span></span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\">Advanced<span style=\"[%2$s]\"> focus analysis</span></span>" |
*
* @param {Subscription_Walkthrough_P1_Content_StatsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_content_stats = /** @type {((inputs?: Subscription_Walkthrough_P1_Content_StatsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Content_StatsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_content_stats(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_content_stats(inputs)
	return zh_tw_subscription_walkthrough_p1_content_stats(inputs)
});